import { reactive } from "@vue/composition-api";
import _axios from "@/axios";
import { handleFormErrors } from "@/composables/form-error";
import { useGroup } from "@/composables/group";

export function useGroupBannerFooter() {
  const { currentGroup } = useGroup();
  let groupBannerFooterData = reactive({
    bannerFooterFile: null,
    bannerFooterFormRef: null,
    bannerFooter_fileRules: [],
    dialogForBannerFooter: false,
    deleteDialog: false,
    editedItem: null,
  });

  function uploadBannerFooter(groupId, type) {
    const formData = new FormData();
    if (groupBannerFooterData.bannerFooterFile instanceof Blob) {
      formData.append("file", groupBannerFooterData.bannerFooterFile, "upload");
    }
    formData.append("type", type);

    return _axios
      .post(`/group-upload/${groupId}`, formData, {
        headers: {
          "Content-Type": `multipart/form-data; boundary=${groupBannerFooterData._boundary}`,
        },
      })
      .then((response) => {
        const group = response.data.data;

        currentGroup.value = group;
        groupBannerFooterData.dialogForBannerFooter = false;
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          groupBannerFooterData,
          groupBannerFooterData.bannerFooterFormRef
        );
      });
  }

  function removeBannerFooter(groupId, type) {
    const formData = new FormData();
    formData.append("type", type);

    return _axios
      .post(`/group-remove/${groupId}`, formData)
      .then((response) => {
        const group = response.data.data;

        currentGroup.value = group;
      })
      .catch(() => {});
  }

  return {
    groupBannerFooterData,
    uploadBannerFooter,
    removeBannerFooter,
  };
}
